import React, { useState, useEffect, useRef } from 'react';
import EditableContentMultilang from '../components/EditableContentMultilang';
import './LocationPage.css';
import { useTranslation } from 'react-i18next';
import mapboxgl from 'mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css';

const LocationPage = () => {
    const { t } = useTranslation();
    const [showDirectionsModal, setShowDirectionsModal] = useState(false);
    const mapContainerRef = useRef(null);
    const mapRef = useRef(null);

    // --- LINK AGGIORNATO PER IL PULSANTE INDICAZIONI ---
    const googleMapsLink = "https://maps.app.goo.gl/aPK9881ewqzLKTdF7";

    useEffect(() => {
        if (!mapContainerRef.current || mapRef.current) return;

        mapboxgl.accessToken = 'pk.eyJ1IjoiYW50aWNvcGlvbGRlZmVsdHJlIiwiYSI6ImNtZjZ2ZDBleDA0aW8yaXMxdmF3Z24ycHEifQ.cXrCbFXQTtXEYt4iR3-0Ag';
        
        mapRef.current = new mapboxgl.Map({
            container: mapContainerRef.current,
            style: 'mapbox://styles/anticopioldefeltre/cmnmayfm0001z01sb2nik5anr',
            center: [11.90647867760571, 46.01534675766986],
            zoom: 17.4,
            pitch: 60,
            bearing: -12
        });

        mapRef.current.scrollZoom.setWheelZoomRate(1/1500); 
        mapRef.current.scrollZoom.setZoomRate(1/500);       
        mapRef.current.addControl(new mapboxgl.NavigationControl(), 'bottom-right');

        // Add marker for BnB
        const el = document.createElement('div');
        el.className = 'custom-pin-bnb';
        el.innerHTML = `
          <svg width="28" height="42" viewBox="0 0 24 36" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 0C5.373 0 0 5.373 0 12c0 7.5 12 24 12 24s12-16.5 12-24C24 5.373 18.627 0 12 0z" fill="#2a9d8f"/>
            <circle cx="12" cy="12" r="5" fill="#155d54"/>
          </svg>
        `;
        
        new mapboxgl.Marker({ element: el, anchor: 'bottom' })
            .setLngLat([11.90647867760571, 46.01534675766986])
            .addTo(mapRef.current);

    }, []);

    const renderContent = () => {

        return (
            <div className="location-page">
                <section className="page-header">
                    <div className="container">
                        <EditableContentMultilang docPath="location_page/header" field="title" elementType="h1" />
                    </div>
                </section>

                <section className="content-section location-details-section">
                    <div className="container location-container">
                        <div className="location-info">
                            <EditableContentMultilang docPath="location_page/details" field="address_title" elementType="h2" />
                            <EditableContentMultilang docPath="location_page/details" field="address" elementType="textarea" />
                            
                            {/* --- PULSANTE INDICAZIONI --- */}
                            <div className="directions-button-container">
                                <button onClick={() => setShowDirectionsModal(true)} className="cta-button">
                                    {t('buttonGetDirections')}
                                </button>
                            </div>

                            <EditableContentMultilang docPath="location_page/details" field="directions_title" elementType="h3" />
                            <EditableContentMultilang docPath="location_page/details" field="directions_text" elementType="textarea" />
                            <EditableContentMultilang docPath="location_page/details" field="contact_title" elementType="h3" />
                            <EditableContentMultilang docPath="location_page/details" field="contact_info" elementType="textarea" />
                        </div>

                        {/* --- MAPPA --- */}
                        <div className="location-map">
  <div className="map-responsive-wrapper">
    <div ref={mapContainerRef} style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }} />
  </div>
</div>
                    </div>
                </section>
            </div>
        );
    }
    
    return (
        <>
            {renderContent()}
            {showDirectionsModal && (
                <div className="directions-modal-overlay" onClick={() => setShowDirectionsModal(false)}>
                    <div className="directions-modal-content" onClick={(e) => e.stopPropagation()}>
                        <h3 className="directions-modal-title">{t('chooseNavigationApp')}</h3>
                        <a href={googleMapsLink} className="directions-modal-button google-maps-btn" target="_blank" rel="noopener noreferrer" onClick={() => setShowDirectionsModal(false)}>
                            Google Maps
                        </a>
                        <a href="http://maps.apple.com/?ll=46.015374,11.903925&q=L'Antico+Piol+de+Feltre" className="directions-modal-button apple-maps-btn" target="_blank" rel="noopener noreferrer" onClick={() => setShowDirectionsModal(false)}>
                            Apple Maps
                        </a>
                        <button className="directions-modal-button cancel-btn" onClick={() => setShowDirectionsModal(false)}>
                            {t('buttonCancel')}
                        </button>
                    </div>
                </div>
            )}
        </>
    );
};

export default LocationPage;


